// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2184":"358103e1","8400":"3148b244"}[chunkId] + ".chunk.css";
};